import * as _ from "lodash";
import * as angular from "angular";
import { CanvassStatus } from "../models/canvass-status.model";
import { CanvassStatusService } from "../services/canvass-status.service";

export class CanvassStatusDataProvider {
    private $q: any;
    private $timeout: any;
    private service: CanvassStatusService;

    public canvassStatuses: CanvassStatus[] | null = null;
    public nbStatuses: any = null;
    public getCanvassStatusesPromise: any;
    public statuses: any[];

    constructor(
        $q: any,
        CanvassStatusService: CanvassStatusService,
        $timeout: any
    ) {
        this.$q = $q;
        this.service = CanvassStatusService;
        this.$timeout = $timeout;
    }

    clearAll(): void {
        this.canvassStatuses = null;
        this.getCanvassStatusesPromise = null;
    }

    update(status: CanvassStatus): Promise<any> {
        const deferred = this.$q.defer();
        let data = _.cloneDeep(status);
        this.service.update(data).then((response) => {
            const json = response["data"];
            if (json.success) {
                angular.extend(status, json.data.attributes);
                deferred.resolve(status);
            } else {
                deferred.reject(json);
            }
        });
        return deferred.promise;
    }

    create(status: CanvassStatus): Promise<any> {
        const deferred = this.$q.defer();
        this.service.create(status).then(
            (response) => {
                const json = response["data"];
                if (json.success) {
                    let newStatus = new CanvassStatus(json.data);
                    this.replaceCanvassStatus(newStatus);
                    deferred.resolve(newStatus);
                } else {
                    deferred.reject(json);
                }
            },
            (error) => deferred.reject(error)
        );
        return deferred.promise;
    }

    setStatuses(statuses: any[]): void {
        this.statuses = statuses;
    }

    canvassCount(status: CanvassStatus): Promise<any> {
        const deferred = this.$q.defer();
        this.service.canvassCount({ id: status.id }).then((response) => {
            const json = response["data"];
            if (json.success) {
                deferred.resolve(json.data);
            } else {
                deferred.reject(json);
            }
        });
        return deferred.promise;
    }

    delete(status: CanvassStatus): Promise<any> {
        const deferred = this.$q.defer();
        this.service.delete({ id: status.id }).then((response) => {
            const json = response["data"];
            if (json.success) {
                this.spliceStatus(status);
                deferred.resolve(json.data);
            } else {
                deferred.reject(json);
            }
        });
        return deferred.promise;
    }

    migrate(oldStatus: CanvassStatus, newStatus: CanvassStatus): Promise<any> {
        const deferred = this.$q.defer();
        this.service
            .migrate({ oldStatus: oldStatus.id, newStatus: newStatus.id })
            .then((response) => {
                const json = response["data"];
                if (json.success) {
                    this.spliceStatus(oldStatus);
                    deferred.resolve(json.data);
                } else {
                    deferred.reject(json);
                }
            });
        return deferred.promise;
    }

    spliceStatus(status: CanvassStatus): void {
        angular.forEach(
            this.canvassStatuses,
            (canvassStatus: CanvassStatus, $index: number) => {
                if (canvassStatus.id == status.id) {
                    this.canvassStatuses.splice($index, 1);
                }
            }
        );
    }

    walkCanvassStatuses(): Promise<CanvassStatus[]> {
        const deferred = this.$q.defer();
        if (this.canvassStatuses !== null) {
            deferred.resolve(this.canvassStatuses);
            this.getCanvassStatusesPromise = deferred.promise;
            return this.getCanvassStatusesPromise;
        } else if (this.getCanvassStatusesPromise) {
            return this.getCanvassStatusesPromise;
        } else {
            this.service.all().then(
                (response) => {
                    const json = response["data"];
                    this.canvassStatuses = [];
                    for (let i = 0; i < json.data.length; i++) {
                        this.canvassStatuses.push(
                            new CanvassStatus(json.data[i])
                        );
                    }
                    deferred.resolve(this.canvassStatuses);
                },
                (error) => {
                    this.canvassStatuses = [];
                    deferred.reject(error);
                }
            );
            this.getCanvassStatusesPromise = deferred.promise;
            return this.getCanvassStatusesPromise;
        }
    }

    statusWithID(id: string | number): CanvassStatus {
        for (let i = 0; i < this.canvassStatuses.length; i++) {
            if (this.canvassStatuses[i].id == id) {
                return this.canvassStatuses[i];
            }
        }
        return null;
    }

    replaceCanvassStatus(data: any): void {
        this.$timeout(() => {
            let existingStatus = this.statusWithID(data.id);
            if (existingStatus) {
                angular.extend(existingStatus, data);
            } else {
                let newStatus = new CanvassStatus(data);
                this.canvassStatuses.push(newStatus);
            }
        });
    }

    updateOrder(data: object): Promise<any> {
        const deferred = this.$q.defer();
        this.service.updateOrder(data).then(() => deferred.resolve(data));
        return deferred.promise;
    }

    updateAll(data: CanvassStatus[]): Promise<any> {
        const deferred = this.$q.defer();
        this.service.updateAll(data).then(() => deferred.resolve(data));
        return deferred.promise;
    }

    workflows(data: CanvassStatus[]): Promise<any> {
        const deferred = this.$q.defer();
        this.service.workflows(data).then(() => deferred.resolve(data));
        return deferred.promise;
    }
}

angular
    .module("vcDataProvider")
    .service("CanvassStatusDataProvider", CanvassStatusDataProvider);
